import { faChartLine, faHandshake, faHeart, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { Venue, VenueId } from './venues.types';

export const VENUES: Venue[] = [
    {
        id: VenueId.Grow,
        label: 'Grow',
        description:
            'Develop your veterinary business acumen, improve practice growth and profitability and exchange knowledge and experiences with peers',
        themeClass: 'theme-green',
        icon: faChartLine,
    },
    {
        id: VenueId.Ally,
        label: 'Ally',
        description:
            'Leverage expert services, so you can focus on what you do best',
        themeClass: 'theme-amber',
        icon: faUserGroup,
        hidden: true,
    },
    {
        id: VenueId.Connect,
        label: 'Connect',
        description:
            'Transition the ownership of your practice most effectively, efficiently and profitably.',
        themeClass: 'theme-coral',
        icon: faHandshake,
    },
    {
        id: VenueId.Share,
        label: 'Share',
        description:
            'Spread the word & support others within the industry',
        themeClass: 'theme-purple',
        icon: faHeart,
    },
];
